import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { placeSetSchema } from '../schemas/place-set.schema';

/**
 * Requests the Place Sets associated with specific Vehicle Groups
 * @param ids The vehicle group IDs for the vehicle whose Place Sets are being requested
 * @returns The Place Sets
 */
export function getPlaceSetsVehicleGroups(this: unknown, ids: number[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          fleetEnvironment.resolve(this).placeSetsVehicleGroupsUrl
        }?vehicleGroupIds=${ids.toString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(placeSetSchema.omit({ vehicleGroups: true })),
      })
    )
  );
}
